import FormProgress from '@components/FormProgress';
import DisplayLogo from '@components/Logo/DisplayLogo';
import { isIpac } from '@config/constants';
import { FC, ReactNode } from 'react';
import * as styles from './FormLayout.css';
import Presentation from './Presentation';

interface Props {
  progressPercent: number;
  children: ReactNode;
}

export const FormLayout: FC<Props> = ({ progressPercent, children }) => (
  <div className={styles.fullPageLayout}>
    <Presentation
      progressPercent={progressPercent}
      className={styles.presentationBlock}
    />
    <div className={styles.formBlock}>
      <div className={styles.mobileLogo}>
        <DisplayLogo />
      </div>
      <FormProgress percent={progressPercent} className={styles.progress} />
      <div className={styles.formContainer}>
        {children}
        <div className={styles.footerCopyright}>
          © 2009 • {new Date().getFullYear()} -{' '}
          {isIpac ? 'IPAC ONLINE' : "L'École Française"}
        </div>
      </div>
    </div>
  </div>
);
